import { render, staticRenderFns } from "./prizeRecode.vue?vue&type=template&id=cdd2e63c&scoped=true&"
import script from "./prizeRecode.vue?vue&type=script&lang=js&"
export * from "./prizeRecode.vue?vue&type=script&lang=js&"
import style0 from "./prizeRecode.vue?vue&type=style&index=0&id=cdd2e63c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd2e63c",
  null
  
)

export default component.exports